/** @flow */

import React, { type ElementProps, Component } from "react";
import classNames from "classnames";
import { Tooltip } from "reactstrap";

type TooltipProps = {
  ...ElementProps<typeof Tooltip>,
  title?: string,
  description?: string | React$Node,
  paragraphs?: Array<{
    text: string,
    title?: string,
  }>,
  descriptionWithLink?: Array<{
    text: string,
    link: string,
    textSecondary?: string,
  }>,
  id: string,
  className?: string,
  titleClassName?: string,
  hidden?: boolean,
};

type StateType = {
  tooltipOpen: boolean,
};

class TooltipDropdown extends Component<TooltipProps, StateType> {
  state = {
    tooltipOpen: false,
  };

  toggleTooltip = () => {
    if (!this.props.hidden) {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen,
      });
    }
  };

  render() {
    const props = { ...this.props };
    delete props.className;
    delete props.titleClassName;
    delete props.descriptionWithLink;
    return (
      // TODO Investigate. For some reason if you give any classname from props, tooltip description will be messed up
      <div className={classNames("tooltip-dropdown", this.props.className)}>
        <span id={this.props.id}>{this.props.children}</span>
        <Tooltip
          className={classNames("tooltip-container", this.props.className)}
          arrowClassName="tooltip-arrow"
          placement="top"
          autohide={false}
          toggle={this.toggleTooltip}
          isOpen={this.state.tooltipOpen}
          target={props.id}
          hideArrow={false}
          {...props}
        >
          <React.Fragment>
            {props.title && (
              <div className={classNames("title", this.props.titleClassName)}>{props.title}</div>
            )}
            {
              <>
                {props.description && <div className="description">{props.description}</div>}

                {props.descriptionWithLink &&
                  props.descriptionWithLink.map((item, index) => (
                    <p key={index}>
                      <span>{item.text}</span>
                      {item.link}
                      {item.textSecondary && <span>{item.textSecondary}</span>}
                    </p>
                  ))}
              </>
            }
          </React.Fragment>
        </Tooltip>
      </div>
    );
  }
}

export default TooltipDropdown;
